import React from "react";

const JournalVouchers = () => {
  return <div>Journal voucher is under construction ⚒️...</div>;
};

export default JournalVouchers;
